<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M32 5A22.52 22.52 0 009.5 27.5c0 11.24 17.63 27.65 21.17 30.82a2 2 0 002.66 0C36.87 55.15 54.5 38.74 54.5 27.5A22.52 22.52 0 0032 5zm0 50.48C28.12 51.91 12.5 37 12.5 27.5a19.5 19.5 0 0139 0c0 9.5-15.62 24.41-19.5 27.98z"/><path d="M43.51 19.64l-11-6.5a1 1 0 00-1 0l-11 6.5a1 1 0 00-.49.86v13a1 1 0 00.49.86l11 6.5a1 1 0 001 0l11-6.5a1 1 0 00.49-.86v-13a1 1 0 00-.49-.86zM32 15.16l9 5.34-3.56 2.1-9-5.36zm0 10.68l-9-5.34 3.56-2.11 9 5.37zm-10-3.59l9 5.34v10.68l-9-5.34zm11 16v-10.7l9-5.3v10.68z"/></svg>